import type { DecalDomain } from "../../lib/types";
import { cn } from "../../lib/cn";

interface Props {
  domain: DecalDomain;
  size?: "sm" | "md";
}

const DOMAIN_LABELS: Record<DecalDomain, string> = {
  LICENSING_COMPLIANCE:        "Licensing",
  HEALTH_SAFETY:               "Health & Safety",
  PREK_PROGRAMS:               "Pre-K Programs",
  WORKFORCE:                   "Workforce",
  QUALITY_INITIATIVES:         "Quality Ratings",
  FAMILY_ACCESS_AFFORDABILITY: "Family Access",
  DATA_PRIVACY_REPORTING:      "Data & Privacy",
  TECHNOLOGY_AI_EDUCATION:     "Tech & AI",
  LOTTERY_HOPE_FUNDING:        "Lottery / HOPE",
  CAMPUS_ADJACENT:             "Campus Facilities",
  OTHER_LOW_RELEVANCE:         "Other",
};

export default function DomainPill({ domain, size = "md" }: Props) {
  if (domain === "OTHER_LOW_RELEVANCE") return null;

  return (
    <span
      className={cn(
        "inline-flex items-center rounded bg-primary-light font-medium text-primary",
        size === "sm" ? "px-1.5 py-0.5 text-2xs" : "px-2 py-0.5 text-xs"
      )}
      title={domain}
    >
      {DOMAIN_LABELS[domain]}
    </span>
  );
}
